import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=ebf7ab38&scoped=true&"
import script from "./Primary.vue?vue&type=script&lang=js&"
export * from "./Primary.vue?vue&type=script&lang=js&"
import style0 from "./Primary.vue?vue&type=style&index=0&id=ebf7ab38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf7ab38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebf7ab38')) {
      api.createRecord('ebf7ab38', component.options)
    } else {
      api.reload('ebf7ab38', component.options)
    }
    module.hot.accept("./Primary.vue?vue&type=template&id=ebf7ab38&scoped=true&", function () {
      api.rerender('ebf7ab38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Primary.vue"
export default component.exports